<ng-container *ngIf="!isLandingPage">
  <ds-header 
    [navBarRef]="navBar"
    appName="{{ title }}"
    [userInfo]="userInfo()"
    [themeSwitch]="true"
  ></ds-header>
</ng-container>

<div class="d-flex flex-column min-vh-100">
  <div class="d-flex flex-grow-1">
    <ng-container *ngIf="!isLandingPage">
      <div class="nav-bar-wrapper position-sticky">
        <ds-navigation-bar #navBar [items]="navigationItems()" [isExpanded]="true"></ds-navigation-bar>
      </div>
    </ng-container>

    <main class="container-fluid py-6x flex-grow-1">
      <div class="app-scale-wrapper">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
</div>

<ng-container *ngIf="!isLandingPage">
  <footer class="app-footer border-top">
    <small>&copy; BMW Group 2025</small>
  </footer>
</ng-container>
